import { useReducer, useEffect } from 'react';
import formReducer, { actions } from './reducer';
//import get from 'lodash/get';
/*
const getCaller = () => {
    const stackTrace = new Error().stack;
    const stackSplit = get(stackTrace.split('\n'), '[3]', '').trim();
    const caller = get(stackSplit.split(' '), '[1]', '');
    return caller;
};
*/
const useForm = ({
    initialState, 
    props, 
    onLoad, 
    onSubmit,
    //debug = false
}) => {
    //Check if initialState is an object with keys
    if (!initialState || Object.keys(initialState).length === 0) throw new Error('Must supply initialState');

    const formFields = Object.keys(initialState);
    initialState = {
        values: parseinitialState(formFields, initialState),
        errors: {},
        isValid: null
    };

    const [state, dispatch] = useReducer(formReducer, initialState);
    //const callerComponent = getCaller();
    //if (debug) console.log(callerComponent, state, props);

    const onFail = (result) => {
        //if (debug) console.log(`${callerComponent} onFail`, result);
        if (result.errorType == 'validation') {
            const invalidRequestParameters = result.errors.find(x=> x.code == 'INVALID_REQUEST_PARAMETER');
            //if (debug) console.log(invalidRequestParameters);
            const errors = invalidRequestParameters.errors.reduce((prev, current)=> {
                const key = current.path[0];
                const error = current.message;
                return {
                    ...prev,
                    [key]: error,
                };
            }, {});
            //if (debug) console.log(errors);
            dispatch({type: actions.ON_INVALID_FORM, payload: errors});    
        } else {
            dispatch({ type: actions.ON_SUBMIT_FAIL, payload: result.error });
        }
    };

    
    const load = async () => {
        if (onLoad) {
            const values = await onLoad(state.values, props);
            if (values) {
                //if (debug) console.log(`${callerComponent} onLoad`, values);
                dispatch({type: actions.ON_LOAD, payload: {state: values}});
            }
        }
    };

    useEffect(() => {
        load();
    }, [onLoad]);
    
    return {
        state,
        fieldActions: {
            onChange: (value, path) => {
                //if (debug) console.log(`${callerComponent} onChange`, value, path);
                let newValue = value;
                if (typeof value == 'function') {
                    const newState = value(state.values);
                    return dispatch({type: actions.ON_LOAD, payload: {state: newState}});
                }
                if (value && value.target) {
                    newValue = value.target.value;
                }
                dispatch({ type: actions.FIELD_ERROR_REMOVE, payload: { key: path }});
                dispatch({ type: actions.FIELD_CHANGE, payload: { key: path, value: newValue } });
            },
            onBlur: (value, path, validator) => {
                if (!validator) return;
                const result = validator(value);
                if (result === true) {
                    dispatch({ type: actions.FIELD_ERROR_REMOVE, payload: { key: path } });
                } else {
                    dispatch({ type: actions.FIELD_ERROR_ADD, payload: { key: path, error: result } });
                }
            },
        },
        formActions: {
            submit: async (cb = null, args = {}) => {
                const onInvalidForm = (errors) => {
                    //if (debug) console.log(`${callerComponent} onInvalidForm`, errors);
                    dispatch({type: actions.ON_INVALID_FORM, payload: errors});
                };

                const resetFormErrors = (errors = {}) => {
                    //if (debug) console.log(`${callerComponent} resetFormErrors`, errors);
                    dispatch({type: actions.ON_INVALID_FORM, payload: errors});
                };

                const onSuccess = (values) => {
                    //if (debug) console.log(`${callerComponent} onSuccess`, values);
                    const keys = Object.keys(values);
                    keys.map(x=> {
                        dispatch({ type: actions.FIELD_CHANGE, payload: { key: x, value: values[x] } });
                    });
                };

                const onChange = (value, path) => {
                    //if (debug) console.log(`${callerComponent} onChange`, value, path);
                    dispatch({ type: actions.FIELD_CHANGE, payload: { key: path, value } });
                };
                
                try {
                    const result = onSubmit && await onSubmit({
                        values: state.values, 
                        props,
                        args,
                        onFail, 
                        onInvalidForm, 
                        onSuccess,
                        resetFormErrors,
                        onChange,
                    });
                    if (typeof cb == 'function') cb(result);
                } catch (e) {
                    onFail({error: e.message});
                }
            },
            onFail,
            resetFormErrors: (errors = {}) => {
                //if (debug) console.log(`${callerComponent} resetFormErrors`, errors);
                dispatch({type: actions.ON_INVALID_FORM, payload: errors});
            },
            setError: (error) => {
                dispatch({ type: actions.ON_SUBMIT_FAIL, payload: error });
            },
            getState: () => state,
            setValues: (values) => {
                dispatch({
                    type: actions.ON_LOAD, 
                    payload: {
                        state: {
                            ...state.values,
                            ...values
                        }
                    }});
            },
            reset: () => {
                dispatch({type: actions.RESET, payload: {state: initialState}});
            },
            reload: load,
            update: (obj) => {
                dispatch({type: actions.RESET, payload: {state: obj}});
            },
        }
    };
};

const parseinitialState = (keys, values) => {
    return keys.reduce((prev, curr) => {
        prev[curr] = setValue(values[curr]);
        return prev;
    }, {});
};

const setValue = value => {
    if (value === null || value === undefined) return '';
    return value;
};

export default useForm;